enum UserRoleTypeEnum {
  ADMIN = "ADMIN",
  USER = "USER",
  VIEWER = "VIEWER",
  DRIVER = "DRIVER",
  WASTE_MANAGER = "WASTE_MANAGER",
  LOGISTICS_COORDINATOR = "LOGISTICS_COORDINATOR",
  /** Functional role on top of an access role: confirms or rejects receiving-inspection deviations. */
  DEVIATION_MANAGER = "DEVIATION_MANAGER",
}

export default UserRoleTypeEnum;
